/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * entryform.form
	 * Default handling for the RSVP / Raffle Forms
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "entryform.form", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {

			_this.formData = [];

		};

		/**
		 * init() is executed when DOM is ready.
		 */
		ex.init = function() {

			_this.$wrapper = $(".entryForm");
			_this.$failure = $(".entryForm__fail-message");

			_this.$entryForm = $("#entryForm");
			_this.$hiddenForm = $("#entryFormRecord");
			_this.$prefix = $("#EntryFormPhonePrefix");
			_this.$allFields = $( ".entryForm__field" );

			_this.$generalError = _this.$entryForm.find(".lc-general-error");
			_this.slug = _this.$entryForm.data( "slug" );

		};

		ex.collectFieldValues = function() {

			_this.formData = [];

			_this.$allFields.each( function( k, el ) {

				var $el = $(el),
					$input = $el.find( ":input" ),
					name = $el.data( "field-name" ),
					type = $el.data( "field-type" ),
					fieldData;

				fieldData = {
					name: name,
					isRequired: !!$input.data( "required" ),
					type: type,
					value: $input.val(),
					$input: $input
				};

				if ( fieldData.name === "mobile-prefix" ) {
					return;
				}

				if ( fieldData.name === "mobile-number" ) {
					if ( fieldData.value ) {
						fieldData.value = _this.$prefix.val() + " " + fieldData.value.replace(/\-/g, "").replace(/\s+/g, "");
					}
				}

				switch ( type ) {

					case "checkboxes":

						fieldData.value = $input.filter(":checked").map( function( ck, cel ) {
							return cel.value;
						}).get().join(" | ") || "";

						break;

					case "checkbox":

						fieldData.value = $input.is(":checked");

						break;

					case "radios":

						fieldData.value = $input.filter(":checked").val() || "";

						break;

					case "toggle":

						fieldData.value = $input.is(":checked");

						if ( $input.data("split") ) {
							if ( $input.is(":checked") ) {
								fieldData.value = $input.data("split-true");
							} else {
								fieldData.value = $input.data("split");
							}
						}

						break;

					// no default

				}

				_this.formData.push( fieldData );

			});

			return _this.formData;

		};

		ex.validateFields = function() {

			var errors = [],
				hasPiplPersonal = $( "input[name='pipl_personal']" ).is( ":checked" ),
				hasPiplSensitive = $( "input[name='pipl_sensitive']" ).is( ":checked" ),
				hasPiplXborder = $( "input[name='pipl_xborder']" ).is( ":checked" ),
				hasPiplError = false,
				isCnResidence = $( ".pipl__resident" ).val() === "CN",
				isCnLocale = LC.config.getValue( "profile.locale" ) === "zh_CN",
				piplError = isCnLocale ? "必须勾选所有方框以确认同意" : "All boxes must be checked to confirm consent.";

			ex.collectFieldValues();

			_this.formData.forEach(function( fieldData ) {

				var isEmpty = fieldData.value === "" || typeof fieldData.value === "undefined",
					isChina = _this.$prefix.val() === "86",
					isHongKong = _this.$prefix.val() === "852",
					validChinaNumber = /^(\+?86\s?)?1\d{10}$/.test( fieldData.value ),
					validHongKongNumber = /^(\+?852\s?)?(?!99)\d{8}$/.test( fieldData.value );

				if ( fieldData.isRequired && isEmpty ) {

					errors.push({ errorCode: fieldData.name, errorMessage: Lang.entryForm.required });

				} else if ( fieldData.isRequired && fieldData.type === "checkbox" && fieldData.value === false ) {

					errors.push({ errorCode: fieldData.name, errorMessage: Lang.entryForm.required });

				} else if ( fieldData.name === "mobile-number" && !isEmpty ) {

					if ( isChina && !validChinaNumber || isHongKong && !validHongKongNumber ) {

						errors.push({ errorCode: fieldData.name, errorMessage: Lang.entryForm.invalidPhone });

					}

				}

			});

			if ( isCnResidence ) {

				if ( !hasPiplPersonal ) {
					errors.push( { errorCode: "piplPersonal", errorMessage: "" } );
					hasPiplError = true;
				}

				if ( !hasPiplSensitive ) {
					errors.push( { errorCode: "piplSensitive", errorMessage: "" } );
					hasPiplError = true;
				}

				if ( !hasPiplXborder ) {
					errors.push( { errorCode: "piplXborder", errorMessage: "" } );
					hasPiplError = true;
				}

			}

			if ( hasPiplError ) {

				errors.push( { errorCode: "piplConsent", errorMessage: piplError } );

			}

			if ( errors.length ) {

				LC.pubsub.trigger("forms.showErrors", {
					form: "#entryForm",
					formName: "entryForm_" + _this.slug,
					response: {
						showGeneralErrorMessage: true,
						errorList: errors
					}
				});

			} else {

				_this.$generalError.addClass( ex.hiddenClass );
				_this.sendForm();

			}

		};

		_this.copyData = function() {

			var column = 1, // current column index
				max = 20, // total columns for form
				firstName,
				firstNameIndex,
				lastName,
				lastNameIndex;

			// swap the names around in the stored DB for China
			// so that the result columns are not mixed up with HK/ROW
			if ( LC.helpers.isChinaSite() ) {
				firstNameIndex = _.findIndex( _this.formData, function(i) { return i.name === "firstName"; });
				firstName = _this.formData[ firstNameIndex ];
				lastNameIndex = _.findIndex( _this.formData, function(i) { return i.name === "lastName"; });
				lastName = _this.formData[ lastNameIndex ];
				_this.formData[ firstNameIndex ] = lastName;
				_this.formData[ lastNameIndex ] = firstName;
			}

			_this.formData.forEach( function( field ) {

				var fieldValue = field.value === "" ? "-" : field.value;

				if ( column <= max ) {

					if ( field.name === "email" ) {

						_this.$hiddenForm.find( "#entryForm_email" ).val( fieldValue );

					} else {

						_this.$hiddenForm.find( "#entryForm_" + column ).val( fieldValue );
						column++;

					}

				}

			});

			_this.$hiddenForm.find( "#entryForm_marketingConsent" ).val(
				$(".js-checkbox-signup-consent").is(":checked") );

			_this.$hiddenForm.find( "#entryForm_residentCountry" ).val(
				$(".entryForm .pipl__resident").val() );

			_this.$hiddenForm.find( "#entryForm_piplConsent1" ).val(
				$(".entryForm .pipl__options :checkbox").eq(0).is(":checked") );

			_this.$hiddenForm.find( "#entryForm_piplConsent2" ).val(
				$(".entryForm .pipl__options :checkbox").eq(1).is(":checked") );

			_this.$hiddenForm.find( "#entryForm_piplConsent3" ).val(
				$(".entryForm .pipl__options :checkbox").eq(2).is(":checked") );

		};

		_this.sendForm = function() {

			_this.copyData();

			var ajax;

			ajax = $.ajax({

				url: _this.$hiddenForm.attr( "action" ),
				data: _this.$hiddenForm.serialize(),
				cache: false,
				type: "POST",
				dataType: "JSON"

			});

			ajax.done( function( response ) {

				if ( response && response.isProcessSuccess ) {

					ex.sendSuccess( response );

				} else if ( response && !response.isProcessSuccess ) {

					_this.handleServerErrors( response );

				} else {

					ex.sendFail( response );

				}

			});

			ajax.fail( function( response ) {

				ex.sendFail( response );

			});

		};

		_this.handleServerErrors = function( response ) {

			var errors = [],
				isDuplicateEmail,
				isInvalidEmail;

			isDuplicateEmail = !!_.find(response.errorList, function(v) {
				return v.errorMessage.includes("duplicatedEmail");
			});

			isInvalidEmail = !!_.find(response.errorList, function(v) {
				return v.errorMessage.includes("missingEmail") || v.errorMessage.includes("invalidEmail");
			});

			if ( isInvalidEmail ) {
				errors.push({ errorCode: "email", errorMessage: Lang.entryForm.invalidEmail });
			} else if ( isDuplicateEmail ) {
				errors.push({ errorCode: "email", errorMessage: Lang.entryForm.duplicateEmail });
			}

			LC.pubsub.trigger( "forms.showErrors", {
				form: "#entryForm",
				formName: "#entryForm_" + _this.slug,
				response: {
					showGeneralErrorMessage: true,
					errorList: errors
				}
			});

		};

		ex.submitForm = function( e ) {

			e.preventDefault();
			ex.validateFields();

		};

		ex.sendFail = function( response ) {

			_this.$wrapper.slideUpNicely( function() {
				_this.$failure.slideDownNicely();
			});

		};

		ex.sendSuccess = function( response ) {

			var url = new URI();

			url.segment( "success" );

			LC.preloader.open();
			LC.location.href = url.toString();

		};

		/**
		 * events() is executed last, after the
		 * DOM is ready to receive event bindings.
		 */
		ex.events = function() {

			_this.$entryForm.on( "submit", ex.submitForm );

		};

		/**
		 * subscribe() is executed after setup() and
		 * before the DOM is ready.
		 */
		ex.subscribe = function() {



		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=entryForm.js
